import type { SlotGameStore } from '@gamzix/slot_core';

class ReelFrameComponent extends Game.src.component.BaseComponent {
    protected bonusFrameContainer;
    protected mainFrameContainer;
    protected bonusWinLabel;

    onGameReady() {
        super.onGameReady();

        this.bonusFrameContainer = game.tree.findByName('reel_frame.wrapper_container.bonus_frame');
        this.mainFrameContainer = game.tree.findByName('reel_frame.wrapper_container.main_frame');
        this.bonusWinLabel = game.tree.findByName('reel_frame.wrapper_container.bonus_win_label');
    }

    setBonusFrame(isUpdateBonusWin = true) {
        if (isUpdateBonusWin) this.bonusWinLabel.options.text = game.localization.get('bonus_game.bonus_win_field');
        this.bonusFrameContainer.options.visible = true;
        this.mainFrameContainer.options.visible = false;

        //@ts-ignore
        this.view.forceViewUpdate();
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store
    }

    setMainFrame() {
        if(this.store.gameData.bonusGame.left > 0) {
            this.setBonusFrame(false);
            return;
        }

        this.bonusFrameContainer.options.visible = false;
        this.mainFrameContainer.options.visible = true;

        //@ts-ignore
        this.view.forceViewUpdate();
    }

    getFSMHandlers(): any {
        return {
            ...super.getFSMHandlers(),
            START: {
                ...super.getFSMHandlers()['START'],
                checkRestoreFreeSpinsGame: {
                    on: async () => {
                        this.setMainFrame();
                    },
                },
                checkRestoreBonusGame: {
                    on: async () => {
                        this.setBonusFrame();
                    },
                },
            }
        }
    }
}

//@ts-ignore
Game.src.component.ReelFrameComponent = ReelFrameComponent;

